module.exports = __webpack_public_path__ + "static/img/Image_011.8091bea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/Image_011.jpg
// module id = 4KkU
// module chunks = 3